import { api } from "./common";
import { Id, Function } from "../types";
import { fetchOrgEntities } from "./fetch-org-entities";

type Props = { subscriptionId: Id } & Pick<Function, "id">;

export const deleteFunction = async (props: Props) => {
  await api(`v2/functions/${props.id}`, {
    method: "DELETE",
    headers: { subscriptionid: props.subscriptionId.toString() },
  });

  const { functions } = await fetchOrgEntities(props.subscriptionId);

  return { functions };
};
